import { createSelector } from "@reduxjs/toolkit";
const createAppSelector = createSelector.withTypes();
export {
  createAppSelector
};
